import { render, staticRenderFns } from "./GuidesAdd.vue?vue&type=template&id=013dffd6"
import script from "./GuidesAdd.vue?vue&type=script&lang=js"
export * from "./GuidesAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports